import React from 'react';
import SolutionPageLayout from '../../components/SolutionPageLayout';
import ProfessionalImage from '../../assets/generated-pages/professional-services-ai.png';

export default function Profession() {
  return (
    <SolutionPageLayout
      eyebrow="Professional Services"
      title="Professional Services"
      subtitle="Smart solutions to enhance productivity, compliance, and execution quality."
      description="Vedalytics empowers professional teams with AI-enabled consulting, training, workflow automation, and compliance support so organizations can work smarter, make better decisions, and scale with confidence."
      image={ProfessionalImage}
      stats={[
        { value: 'Smart', label: 'workflow modernization' },
        { value: 'Expert', label: 'consulting and guidance' },
        { value: 'Agile', label: 'training and adoption' },
        { value: 'Ready', label: 'compliance-focused support' },
      ]}
      highlights={[
        { icon: 'workflow', title: 'Consulting Services', text: 'Optimize strategy, operations, and execution models with expert-led planning and technology advisory.' },
        { icon: 'layers', title: 'Training & Development', text: 'Equip teams with practical skills, adoption playbooks, and capability-building programs.' },
        { icon: 'check', title: 'Legal & Compliance', text: 'Support regulated operations with smarter documentation, checks, and process visibility.' },
      ]}
      overviewTitle="Empowering professionals with smarter operating models"
      overviewText="Our professional services blend domain expertise, AI tooling, and structured delivery methods to help teams remove bottlenecks, improve client outcomes, and create repeatable business value."
      overviewPoints={[
        'Streamlined workflows for repeatable, high-quality delivery.',
        'AI-assisted knowledge management and decision support.',
        'Training programs tailored to business and technical users.',
        'Compliance-aware processes for modern professional teams.',
      ]}
      workflowTitle="A structured path from strategy to productivity"
      workflow={[
        { title: 'Assess Needs', text: 'Understand workflows, skill gaps, compliance needs, and service delivery challenges.' },
        { title: 'Design Roadmap', text: 'Create a practical plan for consulting, training, automation, and operational uplift.' },
        { title: 'Enable Teams', text: 'Roll out tools, workshops, playbooks, and AI-assisted workflows with adoption support.' },
        { title: 'Improve Delivery', text: 'Measure outcomes, refine processes, and scale what works across teams.' },
      ]}
      outcomesTitle="What professional teams gain"
      outcomes={[
        'Higher productivity and reduced operational bottlenecks.',
        'Better client communication and service consistency.',
        'Stronger regulatory and process discipline.',
        'Flexible support that scales with business needs.',
      ]}
    />
  );
}
